const phoneCodes = [
    { name: "--Seleccione--", code: "" },
    { name: "Afganistán", code: "+93" },
    { name: "Alemania", code: "+49" },
    { name: "Argentina", code: "+54" },
    { name: "Australia", code: "+61" },
    { name: "Bolivia", code: "+591" },
    { name: "Brasil", code: "+55" },
    { name: "Canadá", code: "+1" },
    { name: "Chile", code: "+56" },
    { name: "China", code: "+86" },
    { name: "Colombia", code: "+57" },
    { name: "Costa Rica", code: "+506" },
    { name: "Cuba", code: "+53" },
    { name: "Ecuador", code: "+593" },
    { name: "Egipto", code: "+20" },
    { name: "El Salvador", code: "+503" },
    { name: "España", code: "+34" },
    { name: "Estados Unidos", code: "+1" },
    { name: "Francia", code: "+33" },
    { name: "Guatemala", code: "+502" },
    { name: "Honduras", code: "+504" },
    { name: "India", code: "+91" },
    { name: "Italia", code: "+39" },
    { name: "Japón", code: "+81" },
    { name: "México", code: "+52" },
    { name: "Nicaragua", code: "+505" },
    { name: "Panamá", code: "+507" },
    { name: "Paraguay", code: "+595" },
    { name: "Perú", code: "+51" },
    { name: "Portugal", code: "+351" },
    { name: "Reino Unido", code: "+44" },
    { name: "República Dominicana", code: "+1" },
    { name: "Uruguay", code: "+598" },
    { name: "Venezuela", code: "+58" }
];

export default phoneCodes;